import {createAuthenticatedApiClient} from './apiClient';

const agendaAPI = createAuthenticatedApiClient();

const getPayload = responseData => responseData?.data || responseData;

/** Variantes frecuentes de listas paginadas / envueltas en JSON. */
const extractAgendaList = payload => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (!payload || typeof payload !== 'object') {
        return [];
    }

    const inner = payload.data !== undefined ? payload.data : payload;

    if (Array.isArray(inner)) {
        return inner;
    }

    if (inner && typeof inner === 'object') {
        if (Array.isArray(inner.data)) {
            return inner.data;
        }

        if (Array.isArray(inner.items)) {
            return inner.items;
        }

        if (Array.isArray(inner.results)) {
            return inner.results;
        }

        if (Array.isArray(inner.records)) {
            return inner.records;
        }
    }

    if (Array.isArray(payload.items)) {
        return payload.items;
    }

    if (Array.isArray(payload.results)) {
        return payload.results;
    }

    return [];
};

/** El backend pagina por defecto (~10); sin esto los eventos nuevos no aparecen en el calendario. */
const AGENDA_LIST_LIMIT = 500;

export const agendaService = {
    async getAll(params = {}) {
        const {data} = await agendaAPI.get('/agenda', {
            params: {limit: AGENDA_LIST_LIMIT, ...params}
        });
        return extractAgendaList(data);
    },

    async getById(id) {
        const {data} = await agendaAPI.get(`/agenda/${id}`);
        return getPayload(data);
    },

    async create(payload) {
        const {data} = await agendaAPI.post('/agenda', payload);
        return getPayload(data);
    },

    async update(id, payload) {
        const {data} = await agendaAPI.put(`/agenda/${id}`, payload);
        return getPayload(data);
    },

    async remove(id) {
        const {data} = await agendaAPI.delete(`/agenda/${id}`);
        return data;
    },

    async listPropuestas(params = {}) {
        const {data} = await agendaAPI.get('/agenda/propuestas', {params});
        return {
            data: Array.isArray(data?.data) ? data.data : extractAgendaList(data),
            pagination: data?.pagination || null
        };
    },

    async getPropuesta(id) {
        const {data} = await agendaAPI.get(`/agenda/propuestas/${id}`);
        return getPayload(data);
    },

    async confirmPropuesta(id, payload) {
        const {data} = await agendaAPI.post(`/agenda/propuestas/${id}/confirmar`, payload);
        return getPayload(data);
    },

    async rejectPropuesta(id, payload = {}) {
        const {data} = await agendaAPI.post(`/agenda/propuestas/${id}/rechazar`, payload);
        return getPayload(data);
    }
};

export const compromisoTypeService = {
    async getAll() {
        const {data} = await agendaAPI.get('/tipos-compromiso');
        return extractAgendaList(data);
    },

    async getById(id) {
        const {data} = await agendaAPI.get(`/tipos-compromiso/${id}`);
        return getPayload(data);
    },

    async create(payload) {
        const {data} = await agendaAPI.post('/tipos-compromiso', payload);
        return getPayload(data);
    },

    async update(id, payload) {
        const {data} = await agendaAPI.put(`/tipos-compromiso/${id}`, payload);
        return getPayload(data);
    },

    async remove(id) {
        const {data} = await agendaAPI.delete(`/tipos-compromiso/${id}`);
        return data;
    }
};

export const notificationService = {
    async getMine() {
        const {data} = await agendaAPI.get('/notificaciones/me');
        return Array.isArray(data) ? data : (data?.data || []);
    },

    async markRead(id) {
        const {data} = await agendaAPI.patch(`/notificaciones/${id}/read`);
        return getPayload(data);
    },

    async markAllRead() {
        const {data} = await agendaAPI.patch('/notificaciones/me/read-all');
        return getPayload(data);
    }
};
